import { useState } from "react";
import { api } from "@/lib/api";
import { Eye, EyeOff } from "lucide-react";

export const SecretValue = ({ testid, masked, field }) => {
  const [val, setVal] = useState(null);
  const toggle = async () => {
    if (val) return setVal(null);
    const { data } = await api.get("/settings/secrets");
    setVal(data[field]);
  };
  return (
    <span className="inline-flex items-center gap-1.5">
      <span data-testid={testid} className="font-mono text-slate-200 break-all">{val || masked}</span>
      <button data-testid={`${testid}-reveal`} type="button" onClick={toggle} title={val ? "Ocultar" : "Mostrar"}
        className="rounded p-0.5 text-slate-500 transition-colors hover:text-white">
        {val ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
      </button>
    </span>
  );
};
